import { IPlatform as $IPlatform } from '@aurelia/kernel';
export const IPlatform = $IPlatform;
//# sourceMappingURL=platform.js.map